export default __webpack_public_path__ + "static/media/icon-doctor-motif.a51b17da.svg";